import React, { useContext, useEffect, useRef } from "react";
import { ventanas } from "../App.js";
import "../styles/Ventana_Inicial.css";

import Carrusel from "./Carrusel.jsx";

import toro from "../assets/images/toroR.png";

function Ventana_Inicial() {
  const { ventana, setVentana } = useContext(ventanas);

  function vista_centro() {
    return (
      <div className="content-vistaCentro">
        <Carrusel></Carrusel>
        <div className="content-textimg">
          <div className="resumen-presentacion">
            <label className="titulo-resumen1">Clinica Veterinaria</label>
            <label className="titulo-resumen2">EL TORO MACHO</label>
            <label className="contenido-resumen">
              Somos una clinica veterinaria con más de 20 años de experiencia,
              nuestros Doctores estan capacitados para la mejor atención.
            </label>
            <div
              className="boton-contacto"
              onClick={(e) => {
                setVentana("ventana_contacto");
              }}
            >
              Contacto
            </div>
          </div>
          <div className="content-imagenCentral">
            <img src={toro} className="fondo-toro"></img>
          </div>
        </div>
      </div>
    );
  }

  return <div className="content-ventanaInicial">{vista_centro()}</div>;
}

export default Ventana_Inicial;
